import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../services/auth-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientServiceService } from '../services/client-service.service';
import { LangService } from '../services/lang.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {

  auth_token: any = null;
  customer_email: string = "anonymus";
  customer_form_emails: any = [];

  isFullAccess: boolean = false;
  isSubcustomer: boolean = false;
  isInactive: boolean = false;

  isLangModalOpen = false;

  langOptions = [
    { code: 'en', name: 'English',    flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch',    flag: '🇩🇪' },
    { code: 'ja', name: '日本語',      flag: '🇯🇵' },
    { code: 'es', name: 'Español',    flag: '🇪🇸' },
    { code: 'fr', name: 'Français',   flag: '🇫🇷' },
  ];

  constructor(
    private auth_service: AuthServiceService,
    private client_service: ClientServiceService,
    private router: Router,
    private active_router: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public lang: LangService
  ) {}

  ngOnInit(): void {
    this.auth_token = localStorage.getItem("auth_client_token");
    if(!this.auth_token) {
      this.router.navigate(["/login"]);
    }
    this.get_customer_form_emails()
  }

  onLogoClick() {
    if (this.client_service.is_creation_form_pending) {
      return;
    }
    this.active_router.queryParams.subscribe(params => {
      const email = params['email'] || null;

      if (email) {
        window.location.href = `/dashboard?email=${email}`;
        return;
      }

      window.location.href = '/dashboard';
    })
  }

  get_customer_form_emails() {
    this.client_service.get_client_forms(this.auth_token).subscribe({
      next: (data) => {
        if (data.length === 0) {
          this.isFullAccess = false;
          this.get_customer_info();
          return;
        }
        this.isFullAccess = true;
        this.active_router.queryParams.subscribe(params => {
          this.customer_email = params['email'] || null;
          this.customer_form_emails = data.map((form: any) => form.email);
          if ((this.customer_email && !this.customer_form_emails.includes(this.customer_email)) || (!this.customer_email)) {
            this.customer_email = this.customer_form_emails[0];
            this.cdr.detectChanges();
          }
          this.customer_form_emails = this.customer_form_emails.filter((email: any) => email !== this.customer_email);
          this.cdr.detectChanges();
          this.get_customer_info();
        }); 
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  get_customer_info() {
    this.client_service.get_customer_info(this.auth_token).subscribe({
      next: (data) => {
        if (this.customer_email === "anonymus") {
          this.customer_email = data.email;
        }
        if (data.parent_id) {
          this.isSubcustomer = true;
        }
        if (data.status !== 'Active') {
          this.isInactive = true;
        }
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  logout(event: Event) {
    event.preventDefault();
    this.auth_service.auth_logout(this.auth_token).subscribe({
      next: (data) => {
        localStorage.removeItem("auth_client_token");
        this.router.navigate(["/login"]);
      },
      error: (err) => {
        localStorage.removeItem("auth_client_token");
        this.router.navigate(["/login"]);
        // console.log(err);
      }
    })
  }

  openLangModal(): void {
    this.isLangModalOpen = true;
    document.body.style.overflow = 'hidden';
  }

  closeLangModal(): void {
    this.isLangModalOpen = false;
    document.body.style.overflow = '';
  }

  selectLang(code: string): void {
    this.lang.setLang(code);
    this.closeLangModal();
  }
}
